import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export function createStore (config = {}) {
  const store = new Vuex.Store(config)
  store.commit('activateFlashs')
  return store
}
